export function PickemsRewardsMinimumParticipantsNote({
  rewardsNotice,
}: {
  rewardsNotice: string;
}) {
  return (
    <div className="rounded-lg bg-component-bg p-3 text-gray text-xs">
      {rewardsNotice}
    </div>
  );
}
